import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";
import Alert from "../../icons/alert";
import Loader from "../../shared/Loader";
import __ from "../../utils/getContent";

const ZipField = ({
	registeredName,
	label,
	description,
	isRequired,
	requiredText,
	placeholder,
	customValidation,
	isValidating,
	defaultValue,
	disabled,
	onBlur,
	minLength = 0,
	maxLength = 0,
	city,
	state,
}: {
	registeredName: string;
	label: string;
	description?: string;
	isRequired: boolean;
	requiredText?: string;
	placeholder?: string;
	customValidation?: () => string | Promise<string | undefined>;
	isValidating?: boolean;
	defaultValue?: string;
	disabled?: boolean;
	onBlur?: () => string | Promise<string | undefined | void>;
	minLength?: number;
	maxLength?: number;
	city?: string;
	state?: string;
}) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	const disabledClass = disabled ? " bg-gray-200 border-gray-400" : "";
	const cssClass =
		"border border-black w-full py-3 px-2 placeholder:uppercase" +
		disabledClass;

	return (
		<>
			<div className="mb-3 w-full">
				<label
					className="ml-2 flex items-center gap-1 text-sm uppercase"
					htmlFor={`input-${registeredName}`}
				>
					{label}
					{isRequired && "*"}
					{description && (
						<span className="ml-2 flex gap-1 text-xs lowercase">
							<Alert size="xs" />
							{description}
						</span>
					)}
					{isValidating && (
						<Loader colorCircle="#000" colorRotator="#ddd" size="w-3 h-3" />
					)}
				</label>
				{errors && (
					<p className="mb-1 ml-2 text-xs text-red-500">
						<ErrorMessage errors={errors} name={registeredName} />
					</p>
				)}
				<input
					type="text"
					defaultValue={defaultValue || ""}
					{...register(registeredName, {
						onChange: onBlur,
					})}
					name={registeredName}
					id={`input-${registeredName}`}
					placeholder={placeholder}
					className={cssClass}
					disabled={disabled}
					required={isRequired}
					minLength={minLength}
					maxLength={maxLength > 0 ? maxLength : undefined}
				/>
			</div>

			{city && state ? (
				<div className="mb-2 ml-2 flex gap-2 text-sm font-bold italic opacity-50">
					{city}, {state}
				</div>
			) : null}
		</>
	);
};
export default ZipField;
